import { Component, OnInit } from "@angular/core";
import { SessionService } from "src/app/services/session.service";
import { Router } from "@angular/router";
import { ModalAuthService } from "src/app/services/ux/modal-auth.service";
import { toastrService } from "src/app/services/ux/toastr.service";
import { environment } from "src/environments/environment";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "mobile-nav",
  templateUrl: "mobile-nav.component.html"
})
export class MobileNavComponent implements OnInit {
  openSideBar = false;
  isLogged = false;
  environment: any;
  isBanking: boolean

  constructor(
    private session: SessionService,
    private router: Router,
    private AuthModalService: ModalAuthService,
    public toastr: toastrService,
    private translateService: TranslateService
  ) {
    this.environment = environment;
    this.isBanking = environment.env === "banking"
  }

  toggleSideBar() {
    this.openSideBar = !this.openSideBar;
    // check if user is logged
    // check session
    if (this.session.isLoggedIn()) {
      this.isLogged = true;
    } else {
      this.isLogged = false;
    }
  }

  ngOnInit() {}

  /**
   * @TODO: logout in backend
   */
  logout() {
    this.session.logout();
    this.router.navigate(["/"]);
    this.isLogged = false;

    this.toastr.success(this.translateService.instant("LogoutSuccessfully"));
    this.toggleSideBar();
  }

  // login
  login() {
    // open login modal
    this.AuthModalService.open();

    // close sidebar
    this.toggleSideBar();
  }
}
